<!--
 * @Descripttion: 复制大屏下的控制器
 * @version: 
 * @Author: szj
 * @Date: 2023-07-13 19:48:42
 * @LastEditors: szj
 * @LastEditTime: 2025-02-26 17:30:49
-->
<template>
  <div class="controls-box1" ref="controlsBox1">
    <!-- 吊舱操作 -->
    <div class="pod-box1">
      <div class="pod-header1">
        <div class="flex-display flex-align-center">
          <span>吊舱操作</span>
          <!-- @change="dockSwitchChange" -->
          <!-- <span style="margin-left: 5px"
            ><a-switch v-model:checked="podChecked" 
          /></span> -->
          <div
            class="blocks1"
            :style="{
              background: ornamentFlags ? 'green' : 'red',
              marginLeft: '10px',
            }"
          ></div>
        </div>
      </div>
      <div class="pod-content1">
        <!-- 按钮 -->
        <div class="pod-btn-box1">
          <div
            class="pod-btn1"
            @click="checkPodType('wide')"
            :class="vedioType == 'wide' ? 'pod-btn-active' : ''"
          >
            广角
          </div>
          <div
            class="pod-btn1"
            @click="checkPodType('zoom')"
            :class="vedioType == 'zoom' ? 'pod-btn-active' : ''"
          >
            变焦
          </div>
          <div
            class="pod-btn1"
            @click="checkPodType('ir')"
            :class="vedioType == 'ir' ? 'pod-btn-active' : ''"
          >
            红外
          </div>
        </div>
        <div class="flex-display flex-align-center flex-justify-center">
          <div class="pod-line1"></div>
        </div>
        <div class="pod-btn-box1">
          <div class="flex-display">
            <div
              class="pod-btn1"
              @click="photoChange(true)"
              :class="photoType == 'photo' ? 'pod-btn-active' : ''"
            >
              拍照
            </div>
            <div
              class="pod-btn1"
              @click="photoChange(false)"
              :class="photoType == 'record' ? 'pod-btn-active' : ''"
            >
              录制
            </div>
          </div>
          <div class="pod-img-box">
            <a-tooltip placement="right" v-if="photoType == 'photo'">
              <template #title>
                <span>拍照</span>
              </template>
              <div
                @click="takePhoto"
                @mouseenter="paizhaoEnter"
                @mouseleave="paizhaoLeave"
              >
                <img :src="paizhaoblue" alt="" v-if="takephotoFlag" />
                <img :src="controlCheck" alt="" v-else />
              </div>
            </a-tooltip>
            <a-tooltip
              placement="right"
              v-if="photoType == 'record' && startVedio"
            >
              <template #title>
                <span>开始录制</span>
              </template>
              <div @click="startRecord">
                <img
                  :src="paizhaoblue"
                  alt=""
                  style="width: 35px; height: 35px"
                />
              </div>
            </a-tooltip>
            <a-tooltip
              placement="right"
              v-if="photoType == 'record' && !startVedio"
            >
              <template #title>
                <span>结束录制</span>
              </template>
              <div @click="stopRecord">
                <img :src="shiping" alt="" style="width: 35px; height: 35px" />
              </div>
            </a-tooltip>
          </div>
        </div>
        <div class="flex-display flex-align-center flex-justify-center">
          <div class="pod-line1"></div>
        </div>
        <!-- 云台 -->
        <div>
          <div class="gimbal-option1">
            <div
              v-for="(item, index) in GimbalResetModeOptions"
              :key="index"
              class="gimbal-option-item1"
              :style="{
                border:
                  gimbalResetPopoverData.resetMode == item.value
                    ? '1px solid #fff'
                    : '',
              }"
            >
              <a-tooltip placement="right">
                <template #title>
                  <span>{{ item.label }}</span>
                </template>

                <div style="cursor: pointer" @click="gimbalClick(item.value)">
                  <img
                    :src="gimcenter1"
                    alt=""
                    style="width: 20px"
                    v-if="item.value == 0"
                  />
                  <img
                    :src="gimcenter2"
                    alt=""
                    style="width: 20px"
                    v-if="item.value == 1"
                  />
                  <img
                    :src="gimcenter3"
                    alt=""
                    style="width: 20px"
                    v-if="item.value == 2"
                  />
                  <img
                    :src="gimcenter4"
                    alt=""
                    style="width: 20px"
                    v-if="item.value == 3"
                  />
                </div>
              </a-tooltip>
            </div>
          </div>
        </div>
        <div class="flex-display">
          <div class="operate-direction1">
            <div class="ptz-block1">
              <div
                class="ptz-cell ptz-circle-center"
                title="云台-回中"
                @click="gimbalClick(0)"
              >
                <div class="ptz-circle1"></div>
              </div>
              <div
                class="ptz-cell ptz-up"
                title="云台-上"
                @click="directions('up')"
              >
                <span class="ptz-box"><UpOutlined /></span>
              </div>
              <div
                class="ptz-cell ptz-left"
                title="云台-左"
                @click="directions('lf')"
              >
                <span class="ptz-box"><LeftOutlined /></span>
              </div>
              <div
                class="ptz-cell ptz-right"
                title="云台-右"
                @click="directions('rh')"
              >
                <span class="ptz-box"><RightOutlined /></span>
              </div>
              <div
                class="ptz-cell ptz-down"
                title="云台-下"
                @click="directions('dw')"
              >
                <span class="ptz-box"><DownOutlined /></span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-display flex-align-center flex-justify-center">
          <!-- <div style="color:#00D590">
            {{ zoomNum }}
          </div> -->
          <div class="operate-plus-box">
            <div class="ptz-add1" @click="zoomChange('add')" title="焦距-加">
              <PlusOutlined />
            </div>
            <div
              class="ptz-circle1"
              @click="zoomChange('reset')"
              title="重置焦距"
            ></div>
            <div class="ptz-add1" @click="zoomChange('sub')" title="焦距-减">
              <MinusOutlined />
            </div>
          </div>
        </div>
        <div class="con-zoom-scale-box1">
          <div class="con-zoom-scale1">
            <!-- `${rangeNumber}%` -->
            <div
              class="con-current-scale"
              :style="{ bottom: getRangeNumber() }"
            >
              <div class="con-current-scale-inner"></div>
            </div>
            <div
              class="con-current-scale drag"
              draggable="true"
              :style="{ bottom: getRangeNumber() }"
            >
              <div class="con-current-scale-inner"></div>
            </div>
            <div
              class="con-current-scale-label1"
              :style="{ bottom: getRangeNumber() }"
            >
              <span>{{ zoomNumMqtt }}</span>
              <!-- <div v-if="deviceInfoData?.device?.cameras && deviceInfoData?.device?.cameras.length > 0">
                <span v-if="vedioType == 'zoom'">
                  {{ deviceInfoData?.device?.cameras[0]?.zoom_factor }}
                </span>
                <span v-if="vedioType == 'ir'">
                  {{ deviceInfoData?.device?.cameras[0]?.ir_zoom_factor }}
                </span>
              </div>
              <span v-else>
                {{ zoomNum }}
              </span> -->
            </div>
            <div class="con-point-container" style="bottom: 0%">
              <span class="con-point"></span>
              <span class="con-label1">2X</span>
            </div>
            <div class="con-point-container" style="bottom: 100%">
              <span class="con-point"></span>
              <span class="con-label1">200X</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 角度 -->
    <div class="deg-box1">
      <div class="pod-header1 flex-display">
        <div class="pod-titles">无人机实时状态</div>
      </div>
      <div class="deg-content1">
        <!-- 云台偏航角 -->
        <div class="gimbal">
          <div class="yaw-editor with-button">
            <div class="yaw-limit">
              <div class="limit-marker" style="transform: rotate(-90deg)"></div>
              <div class="limit-marker" style="transform: rotate(90deg)"></div>
            </div>
            <div class="yaw-compass active">
              <img
                :src="photoImg"
                :style="{
                  transform: `rotate(${
                    deviceInfoData?.device?.attitude_head
                      ? deviceInfoData?.device?.attitude_head * -1
                      : 0
                  }deg)`,
                }"
              />
            </div>
            <div class="yaw-drone">
              <img :src="zhibiao" alt="" style="width: 30px" />
            </div>
            <div class="yaw-gimbal">
              <span
                class="gimbal-icon"
                style="font-size: 14px"
                :style="{
                  transform: `rotate(${
                    deviceInfoData?.device?.payloads &&
                    deviceInfoData?.device?.payloads[0]?.gimbal_yaw
                      ? deviceInfoData.device.payloads[0].gimbal_yaw -
                        deviceInfoData?.device?.attitude_head
                      : 0
                  }deg)`,
                }"
              >
                <span class="gimbal-icon-inner" style="font-size: 12px"></span>
              </span>
            </div>
            <span class="angle-number degree drone map-text-shadow">{{
              // deviceInfoData?.device?.attitude_head
              //   ? deviceInfoData?.device.attitude_head.toFixed(1)
              //   : 0
              deviceInfoData?.device?.payloads &&
              deviceInfoData?.device?.payloads[0]?.gimbal_yaw
                ? (
                    deviceInfoData.device.payloads[0].gimbal_yaw -
                    deviceInfoData?.device?.attitude_head
                  ).toFixed(1)
                : 0
            }}</span>
          </div>
        </div>
        <div class="con-rod-box">
          <div class="con-pitch-editor">
            <div class="pitch-bar"></div>
            <div class="con-markers" style="top: 37.5%"></div>
            <div class="con-markers zero-markers"></div>
            <div class="con-markers" style="top: 68.75%"></div>
            <div class="con-markers" style="top: 87.5%"></div>
            <div class="con-markers limit-markers" style="top: 31.25%"></div>
            <div class="gimbal-icons" :style="{ top: getGimbalYTop() }">
              <div class="gimbal-icons-inner"></div>
            </div>
            <div class="con-angle-numbers">{{ gimbalInfo.gimbal_y }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 无人机操作 -->
    <div class="docksys-box1">
      <div class="pod-header1 flex-display flex-justify-between">
        <div>
          <span>无人机操作</span>
          <span style="margin-left: 5px"
            ><a-switch
              v-model:checked="dockCheckFlag[checkDockSn]"
              @change="dockSwitchChange"
          /></span>
        </div>
      </div>
      <div class="docksys-item-box1">
        <div style="width: 40%">
          <div
            class="docksys-item1"
            v-if="dockCheckFlag[checkDockSn] && !takeoffFlag"
            @click="flyToPoint"
          >
            <img :src="qifei1" alt="" />
            <span> 起飞 </span>
          </div>
          <!-- 禁用 -->
          <div class="docksys-item-no1" v-else>
            <img :src="qifei" alt="" />
            <span> 起飞 </span>
          </div>
        </div>
        <div style="width: 40%">
          <div
            class="docksys-item1"
            v-if="dockCheckFlag[checkDockSn]"
            @click="sendControlCmd(cmdItem)"
          >
            <img :src="fanhang1" alt="" />
            <span> 返航 </span>
          </div>
          <!-- 禁用 -->
          <div class="docksys-item-no1" v-else>
            <img :src="fanhang" alt="" />
            <span> 返航 </span>
          </div>
        </div>
        <div style="width: 40%">
          <div
            class="docksys-item1"
            v-if="dockCheckFlag[checkDockSn]"
            @click="onResetLine"
          >
            <!--  && resetBtn -->
            <img :src="kaishi1" alt="" />
            <span> 恢复 </span>
          </div>
          <!-- 禁用 -->
          <div class="docksys-item-no1" v-else>
            <img :src="kaishi" alt="" />
            <span> 恢复 </span>
          </div>
        </div>
        <div style="width: 40%">
          <div
            class="docksys-item1"
            v-if="dockCheckFlag[checkDockSn]"
            @click="pauseLine"
          >
            <!-- && !resetBtn -->
            <img :src="zanting1" alt="" />
            <span> 急停 </span>
          </div>
          <!-- 禁用 -->
          <div class="docksys-item-no1" v-else>
            <img :src="zanting" alt="" />
            <span> 急停 </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 飞行默认参数 -->
    <div class="fly-num-box1">
      <div class="key-box">
        <div class="pod-header1 flex-display flex-justify-between">
          <div>
            <span>{{
              flightController ? "释放远程控制" : "获取远程控制"
            }}</span>
            <span style="margin-left: 5px">
              <a-switch
                v-model:checked="switchControlFlag[checkDockSn]"
                @change="checkChange"
              />
              <!-- :disabled=" !wayStatus" -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="drone-control-direction">
            <div style="margin-bottom: 5px; display: flex">
              <div class="">
                <!--  -->
                <Button
                  size="small"
                  @mousedown="onMouseDown(KeyCode.KEY_Q)"
                  @mouseup="onMouseUp(KeyCode.KEY_Q)"
                  :disabled="!flightController || planeStatus"
                  class="key-btn"
                >
                  <template #icon><UndoOutlined /></template
                  ><span class="word">Q</span>
                </Button>
              </div>
              <div class="key-absolute key-w">
                <!-- 前进w右旋转E上升t向左移动A向后移动s向右移动D下降 -->
                <Button
                  size="small"
                  @mousedown="onMouseDown(KeyCode.KEY_W)"
                  @mouseup="onMouseUp(KeyCode.KEY_W)"
                  :disabled="!flightController || planeStatus"
                  class="key-btn"
                >
                  <template #icon><UpOutlined /></template
                  ><span class="word">W</span>
                  <!-- <span class="fs12">前进</span> -->
                </Button>
              </div>
              <div class="key-absolute key-e">
                <Button
                  size="small"
                  class="key-btn"
                  @mousedown="onMouseDown(KeyCode.KEY_E)"
                  @mouseup="onMouseUp(KeyCode.KEY_E)"
                  :disabled="!flightController || planeStatus"
                >
                  <template #icon><RedoOutlined /></template
                  ><span class="word">E</span>
                </Button>
              </div>
              <div class="key-absolute key-up">
                <Button
                  size="small"
                  @mousedown="onMouseDown(KeyCode.ARROW_UP)"
                  @mouseup="onMouseUp(KeyCode.ARROW_UP)"
                  :disabled="!flightController || planeStatus"
                  class="key-btn"
                >
                  <template #icon><ArrowUpOutlined /></template>
                </Button>
              </div>
            </div>
            <!-- <br /> -->
            <div style="display: flex; position: relative">
              <div class="">
                <Button
                  size="small"
                  @mousedown="onMouseDown(KeyCode.KEY_A)"
                  @mouseup="onMouseUp(KeyCode.KEY_A)"
                  :disabled="!flightController || planeStatus"
                  class="key-btn"
                >
                  <template #icon><LeftOutlined /></template
                  ><span class="word">A</span>
                  <!-- <span class="fs12">左&nbsp;&nbsp;&nbsp;移</span> -->
                </Button>
              </div>
              <div class="key-absolute key-s">
                <Button
                  size="small"
                  @mousedown="onMouseDown(KeyCode.KEY_S)"
                  @mouseup="onMouseUp(KeyCode.KEY_S)"
                  :disabled="!flightController || planeStatus"
                  class="key-btn"
                >
                  <template #icon><DownOutlined /></template
                  ><span class="word">S</span>
                  <!-- <span class="fs12">后退</span> -->
                </Button>
              </div>
              <div class="key-absolute key-d">
                <Button
                  size="small"
                  @mousedown="onMouseDown(KeyCode.KEY_D)"
                  @mouseup="onMouseUp(KeyCode.KEY_D)"
                  :disabled="!flightController || planeStatus"
                  class="key-btn"
                >
                  <template #icon><RightOutlined /></template
                  ><span class="word">D</span>
                </Button>
              </div>
              <div class="key-absolute key-down">
                <Button
                  size="small"
                  @mousedown="onMouseDown(KeyCode.ARROW_DOWN)"
                  @mouseup="onMouseUp(KeyCode.ARROW_DOWN)"
                  :disabled="!flightController || planeStatus"
                  class="key-btn"
                >
                  <template #icon><ArrowDownOutlined /></template>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {
  ref,
  reactive,
  createVNode,
  onMounted,
  watch,
  computed,
  onBeforeMount,
} from "vue";
import controlCheck from "/@/assets/icons/controlCheck.png";
import paizhaoblue from "/@/assets/icons/paizhaoblue.png";
import shiping from "/@/assets/icons/shiping.png";
import photoImg from "/@/assets/icons/photoimg.svg";
import zhibiao from "/@/assets/icons/zhibiao1.png";
import qifei from "/@/assets/icons/qifei.png";
import qifei1 from "/@/assets/icons/qifei1.png";
import kaishi from "/@/assets/icons/kaishi.png";
import kaishi1 from "/@/assets/icons/kaishi1.png";
import zanting from "/@/assets/icons/zanting.png";
import zanting1 from "/@/assets/icons/zanting1.png";
import fanhang from "/@/assets/icons/fanhang.png";
import fanhang1 from "/@/assets/icons/fanhang1.png";
import zitai from "/@/assets/icons/zitai1.png";
import fensu from "/@/assets/icons/fensu1.png";
import gimcenter1 from "/@/assets/icons/yuntaiblue1.png";
import gimcenter2 from "/@/assets/icons/yuntaiblue2.png";
import gimcenter3 from "/@/assets/icons/yuntaiblue3.png";
import gimcenter4 from "/@/assets/icons/yuntaiblue4.png";
import plancharge from "/@/assets/icons/dianliang1.png";
import wangluo1 from "/@/assets/icons/wangluo1.png";
import tianqi1 from "/@/assets/icons/tianqi1.png";
import mittBus from "/@/event-bus/mittBus";
import {
  UpOutlined,
  LeftOutlined,
  RightOutlined,
  DownOutlined,
  PlusOutlined,
  MinusOutlined,
  SettingOutlined,
  UndoOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  RedoOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { GimbalResetModeOptions } from "/@/types/drone-control";
import { Button, message, Modal } from "ant-design-vue";
import { useDroneControl } from "/@/components/g-map/use-drone-control";
import { useDockControl } from "/@/components/g-map/use-dock-control";
import { ELocalStorageKey } from "/@/types";
import { getFlyNum } from "/@/api/sys/sys";
import { useMyStore } from "/@/store";
import { postDrcEnter, postDrcExit, postDrc } from "/@/api/drc";
import { clearAimApi, initAimApi, getManualApi } from "/@/api/wayline";
import { KeyCode } from "/@/components/g-map/use-manual-control";
import { controlKeyApi } from "/@/api/drone-control/drone";
import { RainfallEnum } from "/@/types/device";
import { getMapDataApi } from "/@/utils/common";
import {
  noDebugCmdList as baseCmdList,
  DeviceCmdItem,
  DeviceCmd,
} from "/@/types/device-cmd";
import {
  postFlightAuth,
  LostControlActionInCommandFLight,
  WaylineLostControlActionInCommandFlight,
  putResetLine,
} from "/@/api/drone-control/drone";
const props = defineProps({
  // 选中机场的sn
  checkDockSn: {
    type: String,
    default: () => {
      return "";
    },
  },
  // 飞机、机场的实时数据
  checkDeviceInfo: {
    type: Object,
    default: () => {
      return {};
    },
  },
  // 选中飞机的sn
  checkPlanSn: {
    type: String,
    default: () => {
      return "";
    },
  },
  //正在执行任务的jobid
  taskJobId: {
    type: String,
    default: () => {
      return "";
    },
  },
});
const emits = defineEmits([
  "cancalemapclick",
  "cleardata",
  "rightclick",
  "mapclick",
  "aircraftpositionings",
  "aimpoints",
  "toVedio",
  "controlStatus",
  "flightController",
  "mappitch",
  "leftDoubleClick",
]);
const store = useMyStore();
// 无人机控制switch 默认为false 打开后可以点击按钮
const dockChecked = ref<boolean>(false);
// 无人机操作switch键值对
const dockCheckFlag = ref<any>({});
// 吊舱switch 默认为false 打开后可以点击按钮
const podChecked = ref<boolean>(false);
const workspaceId: string =
  localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
// 远程控制
const flightController = ref<boolean>(false);
// 远程控制 switch
const switchController = ref<boolean>(false);
// 远程控制 switch 键值对
const switchControlFlag = ref<any>({});
const controlStatusMessage = ref<any>({});
// 云台
const gimbalResetPopoverData = reactive({
  visible: false,
  loading: false,
  resetMode: null as any,
});
// 起飞 数据
const takeoffToPointPopoverData = reactive({
  visible: false,
  loading: false,
  latitude: null as null | number,
  longitude: null as null | number,
  height: null as null | number,
  securityTakeoffHeight: null as null | number,
  maxSpeed: 14,
  rthAltitude: null as null | number,
  rcLostAction: LostControlActionInCommandFLight.RETURN_HOME,
  exitWaylineWhenRcLost: 0,
});
// 一键起飞 是否禁用 当一键起飞成功后，禁用一键起飞按钮 false不禁用 true禁用
const takeoffFlag = ref<boolean>(false);
// 返航数据
const initCmdList = baseCmdList.find(
  (item) => item.cmdKey === DeviceCmd.ReturnHome
);
// 选中飞机的状态，false为离线，true为在线
const checkPlaneStatus = ref<boolean>(false);
const cmdItem = ref<any>(initCmdList);
// 恢复航线按钮禁用 当有航线正在执行时，点击获取控制设为不禁用 false,恢复航线成功后禁用，默认true禁用
const resetBtn = ref<boolean>(true);
// 远程控制 client id
const clientId = ref<string>("");
// 是否有正在执行的航线任务
const wayStatus = ref<boolean>(false);
// 一键起飞成功后，当飞机的状态为手控时(false)，负载控制和远程控制才可以点击，其余状态为禁用
const planeStatus = ref<boolean>(true);
// 接收传过来的 checkDeviceInfo 值
const deviceInfoData = ref<any>({});
// 接收传过来的 checkDeviceInfo 中的dock值
const deviceInfoDataDock = ref<any>({});
// 偏航角度
const attitudeHead = ref<number>(0);
// 判断偏航角度是否在变化，true为变化
const isAttitude = ref<boolean>(false);
// 是否调用清除数据的接口
const isEnd = ref<boolean>(false);
// 是否可以进行下一次手控操作，true为可以进行手控操作，false不可以
const bolMqttFlags = ref<boolean>(true);
// 是否可以进行下一次焦距操作，true为可以进行焦距操作，false不可以
const ornamentFlags = ref<boolean>(true);
// 视频类型 广角、变焦、红外
const vedioType = ref<string>("wide");
// 拍照：photo 录像 :record
const photoType = ref<string>("photo");
// 开始录像 按钮显示 点击开始录像后，结束录像按钮显示，开始录像隐藏，反之如此
const startVedio = ref<boolean>(true);
// 焦距的值
const zoomNum = ref<number>(2);
const zoomNumMqtt = ref<number>(2);
// 鼠标移入移出拍照的值 false图片为灰色，true 图片为蓝色
const takephotoFlag = ref<boolean>(false);
// 缩放条距离底部的距离
const rangeNumber = ref<number>(0);
// 一键起飞 获取目标点只获取一次
const aimPointInitFlag = ref<boolean>(true);
onMounted(async () => {
  stopWatchList.value = [];
  await initMapSysData();
  getFlyNumHeight();
  getClientId();
});
onBeforeMount(() => {
  mittBus.all.clear();
  if (stopWatchList.value) {
    stopWatchList.value.forEach((stopWatch: any) => stopWatch());
    stopWatchList.value = [];
  }
});
const gimbalInfo = reactive({
  gimbal_y: 0, //云台俯仰轴角度
  gimbal_x: 0,
});
// 地图默认参数
const mapFormState = reactive({
  lng: 104.092518,
  lat: 30.654566,
  maps: 1, // 1 为 ceisum, 2为星图 3 为自有
  mapsxyz: [
    {
      maps: 1, //cesium
      lng: 0,
      lat: 0,
      height: 0,
    },
    {
      maps: 2, //星图
      lng: 0,
      lat: 0,
      height: 0,
    },
    {
      maps: 3, //自有
      lng: 0,
      lat: 0,
      height: 0,
    },
    {
      maps: 4, //mapbox
      lng: 0,
      lat: 0,
      height: 0,
    },
  ] as any,
});

// 初始化地图默认参数
async function initMapSysData() {
  const arrs = await getMapDataApi();
  mapFormState.lng = arrs?.lng ? arrs?.lng : 104.092518;
  mapFormState.lat = arrs?.lat ? arrs?.lat : 30.654566;
  mapFormState.maps = arrs?.maps ? arrs?.maps : 1;
  if (arrs?.mapsxyz) {
    mapFormState.mapsxyz = arrs?.mapsxyz;
  } else {
    mapFormState.mapsxyz = [
      {
        maps: 1, //cesium
        lng: 0,
        lat: 0,
        height: 0,
      },
      {
        maps: 2, //星图
        lng: 0,
        lat: 0,
        height: 0,
      },
      {
        maps: 3, //自有
        lng: 0,
        lat: 0,
        height: 0,
      },
      {
        maps: 4, //mapbox
        lng: 0,
        lat: 0,
        height: 0,
      },
    ];
  }
}
const stopWatchList = ref<any>([]); // 停止 watch

// 监听当前选中机场、飞机的实时数据
// stopWatchList.value.push(
watch(
  () => props.checkDeviceInfo,
  (data) => {
    if (data) {
      deviceInfoData.value = data;
      deviceInfoDataDock.value = data?.dock;
      // 偏航角度 如果存在赋值给 attitudeHead
      if (data?.device?.attitude_head) {
        // 偏航角是否在变化，相等为不变，绝对值大于0.1变化
        if (attitudeHead.value == data?.device?.attitude_head) {
          isAttitude.value = false;
        } else {
          const num = Math.sqrt(
            data?.device?.attitude_head - attitudeHead.value
          );
          if (num > 0.1) {
            isAttitude.value = true;
          } else {
            isAttitude.value = false;
          }
        }
      }
      // data?.basic_osd?.sub_device?.device_online_status 0为飞机关机，1为飞机开机 ，从机场返回的数据判断
      if (data.device && data.device.mode_code > -1) {
        // vedioFlag.value = true
        // 当飞机的状态为手控的时候，负载按钮不禁用
        // console.log(8644,data.device.mode_code,data, data.dock?.basic_osd?.mode_code);
        // 3为手控，7为航线中 5为航线点 2准备中，10着路 9返航
        if (
          data.device.mode_code == 3 ||
          data.device.mode_code == 5 ||
          data.device.mode_code == 16
        ) {
          planeStatus.value = false;
          // mittBus.emit("rightclick", true);
          emits("rightclick", true);
        } else {
          // console.log(9577,data.device.mode_code);

          planeStatus.value = true;
        }
        // 当飞机的状态 3为手控，7为航线中 5为航线点 2准备中，10着路 9返航 时显示 禁用按钮
        if (
          data.device.mode_code == 3 ||
          data.device.mode_code == 7 ||
          data.device.mode_code == 9 ||
          data.device.mode_code == 5 ||
          data.device.mode_code == 2 ||
          data.device.mode_code == 10
        ) {
          // mittBus.emit("mapclick", false);
          emits("mapclick", false);
          // 起飞按钮禁用
          takeoffFlag.value = true;
        }
        // 当机场的状态为空闲的时候，显示一键起飞页面 一键起飞不禁用
        if (data.dock?.basic_osd?.mode_code == 0) {
          // 当为true时地图倾斜角度，false时不倾斜角度
          // emits("mappitch",false)
          if (data.device.mode_code == 0) {
            // 机场 飞机均空闲时清空数据
            setTimeout(() => {
              if (data.device?.mode_code == 0) {
                // 空闲时不选中远程控制
                flightController.value = false;
                switchControlFlag.value[props.checkDockSn] = false;
                dockCheckFlag.value[props.checkDockSn] = false;
                store?.commit("SET_DRC_ENTER_DOCK", []);
                if (!isEnd.value) {
                  clearAimApi(props.checkDockSn).then((res) => {
                    if (res.code == 0 && !res.data) {
                      takeoffToPointPopoverData.latitude = null;
                      takeoffToPointPopoverData.longitude = null;
                      takeoffToPointPopoverData.height = null;
                      takeoffToPointPopoverData.securityTakeoffHeight = null;
                      takeoffToPointPopoverData.rthAltitude = null;
                      aimPointInitFlag.value = true;
                      getFlyNumHeight();
                      // mittBus.emit("cleardata", false);
                      emits("cleardata", false);
                      isEnd.value = true;
                      // 起飞按钮不禁用
                      takeoffFlag.value = false;
                    }
                  });
                }
              }
            }, 5000);
          } else {
            // 如果飞机不是空闲
            isEnd.value = false;
          }
        }
      } else {
        // else 为飞机离线 将角度置为空
        // deviceInfoData.value.device = {};
        deviceInfoData.value = {};
        // 机场空闲
        if (data.dock?.basic_osd?.mode_code == 0) {
          // mittBus.emit("mapclick", true);
          emits("mapclick", true);
        }
        // 当机场为工作状态需要将一键起飞禁用
        if (data.dock?.basic_osd?.mode_code == 4) {
          // mittBus.emit("mapclick", false);
          emits("mapclick", false);
          planeStatus.value = false;
          // 起飞按钮不禁用
          takeoffFlag.value = false;
        }
      }
    } else {
      deviceInfoData.value = {};
    }
    // 云台俯仰轴角度
    if (data?.device?.payloads?.[0]?.gimbal_pitch) {
      const num = data?.device?.payloads?.[0]?.gimbal_pitch.toFixed(1);
      gimbalInfo.gimbal_y = parseFloat(num);
      if (gimbalInfo.gimbal_y >= 45) {
        gimbalInfo.gimbal_y = 45;
      }
      if (gimbalInfo.gimbal_y <= -120) {
        gimbalInfo.gimbal_y = -120;
      }
    } else {
      gimbalInfo.gimbal_y = 0;
    }
    if (
      data?.device?.payloads?.[0]?.gimbal_yaw &&
      data?.device?.attitude_head
    ) {
      const nums = (
        data?.device?.payloads?.[0]?.gimbal_yaw - data?.device?.attitude_head
      ).toFixed(1);

      gimbalInfo.gimbal_x = parseFloat(nums);
      if (gimbalInfo.gimbal_x >= 90) {
        gimbalInfo.gimbal_x = 90;
      }
      if (gimbalInfo.gimbal_x <= -90) {
        gimbalInfo.gimbal_x = -90;
      }
    } else {
      gimbalInfo.gimbal_x = 0;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
// )
// 监听飞行姿态
stopWatchList.value.push(
  watch(
    () => store?.state.manualKey.data,
    (data: any) => {
      // console.log('飞行姿态',data,props.checkPlaneSn);
      if (data && data.length > 0 && props.checkPlanSn) {
        data.map((item: any) => {
          if (item.sn == props.checkPlanSn) {
            controlStatusMessage.value = item.data;
            // console.log(753,controlStatusMessage.value);
          }
        });
      } else {
        controlStatusMessage.value = {};
      }
    },
    {
      deep: true,
    }
  )
);
// 无人机操作 switch change
function dockSwitchChange(val: any) {
  emits("leftDoubleClick", val);
}

// 起飞按钮
function flyToPoint() {
  Modal.confirm({
    title: "提示",
    icon: createVNode(ExclamationCircleOutlined),
    content: `是否进行一键起飞`,
    centered: true,
    class: "modal-class",
    onOk() {
      // const res = await batchDownloadAllFile(params);
      onTakeoffToPointConfirm(true);
    },
    onCancel() {},
  });
}
const { takeoffToPoint } = useDroneControl();
const { sendDockControlCmd } = useDockControl();
// 获取飞行控制默认参数
async function getFlyNumHeight() {
  const res = await getFlyNum({ sysName: "fly_num" }, workspaceId);
  // console.log(1011,res);

  if (res.code == 0) {
    if (res?.data?.sys_value) {
      const sysValue = JSON.parse(res?.data?.sys_value);
      takeoffToPointPopoverData.height = sysValue?.height;
      takeoffToPointPopoverData.securityTakeoffHeight = sysValue?.safeHeight;
      takeoffToPointPopoverData.rthAltitude = sysValue?.gobackHeifht;
      if (takeoffToPointPopoverData.height) {
        const num = takeoffToPointPopoverData.height * 1 + 20;
        localStorage.setItem("HEIGHT", num + "");
      }
    }
  }
}
// 一键起飞 确认
async function onTakeoffToPointConfirm(confirm: boolean) {
  if (confirm) {
    // 获取高度默认值、经纬度
    let lat = localStorage.getItem("LAT");
    let lng = localStorage.getItem("LNG");
    let aslheight = localStorage.getItem("ASLHEIGHT");
    let num = 0;
    if (lat) {
      takeoffToPointPopoverData.latitude = lat * 1;
    }
    if (lng) {
      takeoffToPointPopoverData.longitude = lng * 1;
    }
    if (aslheight) {
      num = parseInt(aslheight) + 20;
      // console.log(723, aslheight, num);
    }
    // 0 为继续执行航线动作
    takeoffToPointPopoverData.exitWaylineWhenRcLost = 0;
    if (
      !props.checkDockSn ||
      !takeoffToPointPopoverData.height ||
      !takeoffToPointPopoverData.latitude ||
      !takeoffToPointPopoverData.longitude ||
      !takeoffToPointPopoverData.securityTakeoffHeight ||
      !aslheight ||
      !takeoffToPointPopoverData.rthAltitude
    ) {
      // message.error("输入错误！");
      return;
    }
    try {
      const heights = parseInt(takeoffToPointPopoverData.height) + num;
      await takeoffToPoint(props.checkDockSn, {
        target_latitude: takeoffToPointPopoverData.latitude,
        target_longitude: takeoffToPointPopoverData.longitude,
        target_height: heights,
        security_takeoff_height:
          takeoffToPointPopoverData.securityTakeoffHeight,
        rth_altitude: takeoffToPointPopoverData.rthAltitude,
        max_speed: takeoffToPointPopoverData.maxSpeed,
        rc_lost_action: takeoffToPointPopoverData.rcLostAction,
        manual_height: takeoffToPointPopoverData.height * 1 + 20,
        exit_wayline_when_rc_lost:
          takeoffToPointPopoverData.exitWaylineWhenRcLost,
      });

      // console.log(741, "asl", heights, takeoffToPointPopoverData.height);
      const heighs = takeoffToPointPopoverData.height * 1 + 20;
      // 将高度、sn存下来
      localStorage.setItem("HEIGHT", heighs + "");
      localStorage.setItem("DOCKSN", props.checkDockSn);
      // 成功后将起飞按钮禁用
      takeoffFlag.value = true;
      // 取消地图设置起飞点
      emits("cancalemapclick", true);
    } catch (error) {}
  }
}
stopWatchList.value.push(
  watch(
    () => props.checkDockSn,
    () => {
      if (props.checkDockSn) {
        const sns = props.checkDockSn;
        aimPointInitFlag.value = true;
        // mittBus.emit("cleardata", false);
        emits("cleardata", false);
        getFlyData(sns);
        if (sns in dockCheckFlag.value) {
          console.log('操作对象包含键 "key"');
        } else {
          dockCheckFlag.value[sns] = false;
        }
        emits("leftDoubleClick", dockCheckFlag.value[sns]);
        if (sns in switchControlFlag.value) {
          console.log('控制对象包含键 "key"');
        } else {
          switchControlFlag.value[sns] = false;
        }
      }
    },
    {
      deep: true,
      immediate: true,
    }
  )
);
// 监听一键起飞数据
stopWatchList.value.push(
  watch(
    () => store?.state.manual.data,
    (data: any) => {
      if (data && data.length > 0) {
        data.map((item: any) => {
          if (item.sn == props.checkDockSn) {
            if (!item.data) {
              return;
            }
            // console.log(1360,item,aimPointInitFlag.value);

            if (
              item.data &&
              item.data.points &&
              item.data.points.length > 0 &&
              aimPointInitFlag.value
            ) {
              item.data.points.map((pointItem: any) => {
                pointItem.height =
                  Number(pointItem.height) +
                  mapFormState.mapsxyz[mapFormState.maps - 1].height;
                pointItem.longitude =
                  Number(pointItem.longitude) +
                  mapFormState.mapsxyz[mapFormState.maps - 1].lng;
                pointItem.latitude =
                  Number(pointItem.latitude) +
                  mapFormState.mapsxyz[mapFormState.maps - 1].lat;
                return pointItem;
              });
              localStorage.setItem("LAT", "");
              localStorage.setItem("LNG", "");
              localStorage.setItem("LAT", item.data.points[0].latitude);
              localStorage.setItem("LNG", item.data.points[0].longitude);
              // 地图不可以打点
              // mittBus.emit("mapclick", false);
              emits("mapclick", false);
              // 如果一键起飞有数据就渲染到地图上
              // mittBus.emit("aimpoints", item.data.points);
              emits("aimpoints", item.data.points);

              aimPointInitFlag.value = false;
            }
            if (item.data.manual_height) {
              takeoffToPointPopoverData.height = item.data.manual_height - 20;
              localStorage.setItem("HEIGHT", item.data.manual_height);
            }
            if (item.data.safe_height) {
              takeoffToPointPopoverData.securityTakeoffHeight =
                item.data.safe_height;
            }
            if (item.data.back_height) {
              takeoffToPointPopoverData.rthAltitude = item.data.back_height;
            }
            if (item.data.fly_height && item.data.manual_height) {
              const height = Number(item.data.fly_height);
              const manualheight = Number(item.data.manual_height);
              const aslheight = height - manualheight;
              localStorage.setItem("ASLHEIGHT", aslheight);
            }

            localStorage.setItem("DOCKSN", props.checkDockSn);
            // mittBus.emit("flysucessWayline", true);
          }
        });
      }
    },
    {
      deep: true,
    }
  )
);
function getFlyData(sns: any) {
  if (!sns) {
    return;
  }
  // return
  // 不用调接口，用推的形式
  initAimApi(sns).then((res) => {
    // console.log(1281, res);

    if (res.code == 0 && res.data) {
      localStorage.setItem("LAT", "");
      localStorage.setItem("LNG", "");
      if (
        res.data.points &&
        res.data.points.length > 0 &&
        aimPointInitFlag.value
      ) {
        res.data.points.map((pointItem: any) => {
          pointItem.height =
            Number(pointItem.height) +
            mapFormState.mapsxyz[mapFormState.maps - 1].height;
          pointItem.longitude =
            Number(pointItem.longitude) +
            mapFormState.mapsxyz[mapFormState.maps - 1].lng;
          pointItem.latitude =
            Number(pointItem.latitude) +
            mapFormState.mapsxyz[mapFormState.maps - 1].lat;
          return pointItem;
        });
        // 地图不可以打点
        // mittBus.emit("mapclick", false);
        emits("mapclick", false);
        localStorage.setItem("LAT", res.data.points[0].latitude);
        localStorage.setItem("LNG", res.data.points[0].longitude);
        // 如果一键起飞有数据就渲染到地图上
        // mittBus.emit("aimpoints", res.data.points);
        emits("aimpoints", res.data.points);

        // 已执行过的航线
        if (
          res?.data?.aircraft_positionings &&
          res?.data?.aircraft_positionings.length > 0
        ) {
          res.data.aircraft_positionings.map((item: any) => {
            item.height =
              Number(item.height) +
              mapFormState.mapsxyz[mapFormState.maps - 1].height;
            item.lon =
              Number(item.lon) +
              mapFormState.mapsxyz[mapFormState.maps - 1].lng;
            item.lat =
              Number(item.lat) +
              mapFormState.mapsxyz[mapFormState.maps - 1].lat;
            return item;
          });
          // mittBus.emit("aircraftpositionings", res.data.aircraft_positionings);
          emits("aircraftpositionings", res.data.aircraft_positionings);
        }
        // aimPointInitFlag.value = false
      }
      if (res.data.manual_height) {
        takeoffToPointPopoverData.height = res.data.manual_height - 20;
        localStorage.setItem("HEIGHT", res.data.manual_height);
      }
      if (res.data.safe_height) {
        takeoffToPointPopoverData.securityTakeoffHeight = res.data.safe_height;
      }
      if (res.data.back_height) {
        takeoffToPointPopoverData.rthAltitude = res.data.back_height;
      }
      if (res.data.fly_height && res.data.manual_height) {
        const height = Number(res.data.fly_height);
        const manualheight = Number(res.data.manual_height);
        const aslheight = height - manualheight;
        localStorage.setItem("ASLHEIGHT", aslheight);
      }

      localStorage.setItem("DOCKSN", props.checkDockSn);
      emits("cancalemapclick", true);
    }
  });
}
//   返航 方法
async function sendControlCmd(cmdItem: DeviceCmdItem) {
  await sendDockControlCmd(
    {
      sn: props.checkDockSn,
      cmd: cmdItem.cmdKey,
      action: cmdItem.action,
    },
    false
  );
  // 点击返航后，将负载控制，进入远程控制按钮 禁用
  planeStatus.value = true;
}
// 恢复航线
async function onResetLine() {
  const res = await putResetLine(workspaceId, props.taskJobId, {
    status: 1,
    sn: props.checkDockSn,
  });
  if (res.code == 0) {
    resetBtn.value = true;
  }
}
// 急停
async function pauseLine() {
  const res = await putResetLine(workspaceId, props.taskJobId, {
    status: 0,
    sn: props.checkDockSn,
  });
  if (res.code == 0) {
    resetBtn.value = false;
  }
}
// 获取 client_id 值
async function getClientId() {
  const result = await postDrc({});
  if (result?.code === 0) {
    const { client_id } = result.data;
    clientId.value = client_id;
  }
}
//   checkbox改变
function checkChange() {
  // 当flightController为false 时退出远程控制
  switchControlFlag.value[props.checkDockSn] =
    !switchControlFlag.value[props.checkDockSn];
  // flightController.value 为true时退出远程控制

  if (flightController.value) {
    Modal.confirm({
      title: "退出远程控制",
      icon: createVNode(ExclamationCircleOutlined),
      content: "退出远程控制后将中断所有飞行",
      centered: true,
      class: "modal-class",
      // getContainer:"() => $refs.controlsBox1",
      async onOk() {
        // 退出远程控制方法
        exitFlightCOntrol();
        flightController.value = false;
        // switchController.value = false;
        switchControlFlag.value[props.checkDockSn] = false;
        return;
      },
      onCancel() {
        flightController.value = true;
        // switchController.value = true;
        switchControlFlag.value[props.checkDockSn] = true;
      },
    });
  } else {
    Modal.confirm({
      title: "获取远程控制",
      icon: createVNode(ExclamationCircleOutlined),
      content: "",
      centered: true,
      class: "modal-class",
      async onOk() {
        putResetLine(workspaceId, props.taskJobId, {
          status: 0,
          sn: props.checkDockSn,
        });
        enterFlightControl();
        flightController.value = true;
        // switchController.value = true;
        switchControlFlag.value[props.checkDockSn] = true;
      },
      onCancel() {
        flightController.value = false;
        // switchController.value = false;
        switchControlFlag.value[props.checkDockSn] = false;
      },
    });
    // 当有航线时执行时，点击了获取飞行控制，地图右键可以打点
    if (wayStatus.value) {
      localStorage.setItem("DOCKSN", props.checkDockSn);
      // mittBus.emit("rightclick", true);
      emits("rightclick", true);
      resetBtn.value = false;
    }
  }
}
// 退出飞行控制
async function exitFlightCOntrol() {
  try {
    await postDrcExit({
      client_id: clientId.value,
      dock_sn: props.checkDockSn,
    });
  } catch (error: any) {}
}
// 进入飞行控制
async function enterFlightControl() {
  console.log(1163, clientId.value);

  try {
    // 获取飞行控制权
    await postDrcEnter({
      client_id: clientId.value,
      dock_sn: props.checkDockSn,
    });
  } catch (error: any) {}
}
// 手控操作
function handleKeyups(keyCode: KeyCode, sn: string, flag: boolean) {
  if (!sn) {
    return;
  }
  switch (keyCode) {
    case "KeyA":
      setOrderDock("a", sn, flag);
      break;
    case "KeyW":
      setOrderDock("w", sn, flag);
      break;
    case "KeyS":
      setOrderDock("s", sn, flag);
      break;
    case "KeyD":
      setOrderDock("d", sn, flag);
      break;
    case "ArrowUp":
      setOrderDock("up", sn, flag);
      break;
    case "ArrowDown":
      setOrderDock("down", sn, flag);
      // activeCodeKey.value = keyCode
      break;
    case "KeyQ":
      setOrderDock("q", sn, flag);
      break;
    case "KeyE":
      setOrderDock("e", sn, flag);
      break;
    default:
      break;
  }
}
// 调用手动控制接口
function setOrderDock(key: string, sn: any, flag: boolean) {
  if (flag == true) {
    controlKeyApi(key, sn);
    // 将mqttFlag值变为false
    store?.commit("SET_MQTT_FLAG", false);
  }
}
// 监听mqttflag的值
stopWatchList.value.push(
  watch(
    () => store?.state.ALL_mqttFlag,
    (val) => {
      bolMqttFlags.value = val;
      // console.log(1177,bolMqttFlags.value);
    },
    {
      deep: true,
    }
  )
);
stopWatchList.value.push(
  watch(
    () => store?.state?.ornamentFlag,
    (val: any) => {
      ornamentFlags.value = val?.success;
      zoomNumMqtt.value = val?.num ? val?.num : zoomNum.value;
      zoomNum.value = zoomNumMqtt.value ? zoomNumMqtt.value : zoomNum.value;
    },
    {
      deep: true,
    }
  )
);
// 手控状态 显示在地图右上角的消息提示
function getControlStatus(sn: any, code: any, action: any) {
  // action true表示按下，false，表示抬起，code表示按下的按键
  let params = {
    sn: sn,
    key: code,
    action: action,
  };
  getManualApi(params);
}
// 远程控制 鼠标按下
function onMouseDown(type: KeyCode) {
  // console.log(819, "mouseDown", type);

  handleKeyups(type, props.checkDockSn, bolMqttFlags.value);
  planeStatus.value = false;
  // 传递给地图上的手控提示
  if (type == KeyCode.KEY_A) {
    getControlStatus(props.checkPlanSn, "a", true);
  }
  if (type == KeyCode.KEY_S) {
    getControlStatus(props.checkPlanSn, "s", true);
  }
  if (type == KeyCode.KEY_D) {
    getControlStatus(props.checkPlanSn, "d", true);
  }
}
//   远程控制 鼠标抬起
function onMouseUp(type: KeyCode) {
  planeStatus.value = false;
  if (type == KeyCode.KEY_A) {
    getControlStatus(props.checkPlanSn, "a", false);
  }
  if (type == KeyCode.KEY_S) {
    getControlStatus(props.checkPlanSn, "s", false);
  }
  if (type == KeyCode.KEY_D) {
    getControlStatus(props.checkPlanSn, "d", false);
  }
}

// 监听是否获取远程控制，val为true 获取远程控制，键盘事件触发，false释放远程控制，键盘事件注销 模拟注释掉
stopWatchList.value.push(
  watch(
    () => flightController.value,
    (val) => {
      if (val) {
        // 触发 键盘抬起事件
        window.addEventListener("keyup", keyupCon);
        window.addEventListener("keydown", keyDownCon);
      } else {
        // 清除键盘事件
        window.removeEventListener("keydown", keyDownCon);
        window.removeEventListener("keyup", keyupCon);
      }
      emits("flightController", flightController.value);
    },
    {
      deep: true,
    }
  )
);
// 触发 键盘抬起事件 模拟放开
// window.addEventListener("keyup", keyupCon);
// window.addEventListener("keydown", keyDownCon);
// 键盘抬起事件
function keyupCon(e: KeyboardEvent) {
  // console.log("按键:", e.key, flightController.value);
  // flightController为true，可以进行远程控制 远程控制按键方法取消
  if (flightController.value) {
    // return;
    if (e.key == "q") {
      planeStatus.value = false;
    }
    if (e.key == "w") {
      planeStatus.value = false;
    }
    if (e.key == "e") {
      planeStatus.value = false;
    }
    if (e.key == "ArrowUp") {
      planeStatus.value = false;
    }
    if (e.key == "a") {
      planeStatus.value = false;
      getControlStatus(props.checkPlanSn, "a", false);
    }
    if (e.key == "s") {
      planeStatus.value = false;
      getControlStatus(props.checkPlanSn, "s", false);
    }
    if (e.key == "d") {
      planeStatus.value = false;
      getControlStatus(props.checkPlanSn, "d", false);
    }
    if (e.key == "ArrowDown") {
      planeStatus.value = false;
    }
    // emits("controlStatus", "");
  }
}
// 键盘按下事件
function keyDownCon(e: KeyboardEvent) {
  // console.log("按键down:", e.key, flightController.value, props.checkPlaneSn);
  // 当flightController为true时，进行远程控制，键盘按下方法
  if (flightController.value) {
    if (e.key == "q") {
      setOrderDock("q", props.checkDockSn, bolMqttFlags.value);
      planeStatus.value = false;
    }
    if (e.key == "w") {
      setOrderDock("w", props.checkDockSn, bolMqttFlags.value);
      planeStatus.value = false;
    }
    if (e.key == "e") {
      setOrderDock("e", props.checkDockSn, bolMqttFlags.value);
      planeStatus.value = false;
    }
    if (e.key == "ArrowUp") {
      setOrderDock("up", props.checkDockSn, bolMqttFlags.value);
      planeStatus.value = false;
    }
    if (e.key == "a") {
      getControlStatus(props.checkPlanSn, "a", true);
      setOrderDock("a", props.checkDockSn, bolMqttFlags.value);
      planeStatus.value = false;
    }
    if (e.key == "s") {
      getControlStatus(props.checkPlanSn, "s", true);
      setOrderDock("s", props.checkDockSn, bolMqttFlags.value);
      planeStatus.value = false;
    }
    if (e.key == "d") {
      getControlStatus(props.checkPlanSn, "d", true);
      setOrderDock("d", props.checkDockSn, bolMqttFlags.value);
      planeStatus.value = false;
    }
    if (e.key == "ArrowDown") {
      setOrderDock("down", props.checkDockSn, bolMqttFlags.value);
      planeStatus.value = false;
    }
  }
}
// 设置云台Y轴的top
function getGimbalYTop() {
  // const gimbaly = 45
  const gimbaly = gimbalInfo.gimbal_y;
  const nums = ((120 - gimbaly) / 240) * 100 + "%";
  return nums;
}
// ************吊舱操作部分**********
// 切换视频类型
function checkPodType(type: string) {
  vedioType.value = type;
  const params = {
    vedioType: type,
    checkPlanSn: props.checkPlanSn,
  };
  // 向视频 传 切换视频的值
  mittBus.emit("vedioSwitch1", params);
  // 将焦距置为2

  if (
    deviceInfoData.value?.device?.cameras &&
    deviceInfoData.value?.device?.cameras.length > 0
  ) {
    if (type == "zoom") {
      zoomNumMqtt.value = deviceInfoData.value?.device?.cameras[0]?.zoom_factor;
    }
    if (type == "ir") {
      zoomNumMqtt.value =
        deviceInfoData.value?.device?.cameras[0]?.ir_zoom_factor;
    }
  }
  zoomNum.value = zoomNumMqtt.value ? zoomNumMqtt.value : zoomNum.value;
}
// 拍照 录像切换
function photoChange(flag: boolean) {
  // true 为拍照 false为录像
  if (flag) {
    photoType.value = "photo";
  } else {
    photoType.value = "record";
  }
  const params = {
    checkPlanSn: props.checkPlanSn,
  };
  mittBus.emit("photoChange1", params);
}
// 拍照
function takePhoto() {
  const params = {
    checkPlanSn: props.checkPlanSn,
  };
  mittBus.emit("takePhoto1", params);
}
// 拍照 鼠标移入 图片为蓝色
function paizhaoEnter() {
  takephotoFlag.value = true;
}
// 拍照 鼠标移入 图片为蓝色
function paizhaoLeave() {
  takephotoFlag.value = false;
}
// 开始录制
function startRecord() {
  const params = {
    checkPlanSn: props.checkPlanSn,
  };
  mittBus.emit("startRecord1", params);
  startVedio.value = false;
}
// 结束录制
function stopRecord() {
  const params = {
    checkPlanSn: props.checkPlanSn,
  };
  mittBus.emit("stopRecord1", params);
  startVedio.value = true;
}
// 云台设置
function gimbalClick(val: any) {
  // console.log(18133,val);
  const params = {
    checkPlanSn: props.checkPlanSn,
    val: val,
  };
  mittBus.emit("gimbalClick1", params);
}
// 控制角度
function directions(val: string) {
  // 用时间戳来传递参数
  const lng = val + new Date().getTime();
  const params = {
    aimDir: lng,
  };
  // mittBus.emit("toVedio", params);
  emits("toVedio", params);
}
// 焦距改变
function zoomChange(val: string) {
  if (vedioType.value == "wide") {
    message.warn("请选择变焦或红外");
    return;
  }
  if (ornamentFlags.value == true) {
    if (val == "add") {
      zoomNum.value++;
      if (zoomNum.value >= 200) {
        zoomNum.value = 200;
      }
    } else if (val == "sub") {
      zoomNum.value--;
      if (zoomNum.value <= 2) {
        zoomNum.value = 2;
      }
    } else if (val == "reset") {
      zoomNum.value = 2;
    }
    const params = {
      num: zoomNum.value,
      type: vedioType.value,
      checkPlanSn: props.checkPlanSn,
    };
    // 将mqttFlag值变为false
    store?.commit("SET_ORNA_FLAG", {
      num: zoomNumMqtt.value ? zoomNumMqtt.value : zoomNum.value,
      success: false,
    });
    // zoomNumBottom()
    mittBus.emit("zoomchange1", params);
  }
}
// 根据焦距计算bottom
// function zoomNumBottom() {
//   let num = parseFloat(((zoomNum.value / (200 - 2)) * 100).toFixed(4))
//   if (num < 0) {
//         num = 0
//     }
//     if (num > 100) {
//         num = 100
//     }
//     // console.log(245,num);
//     rangeNumber.value = num
//   //
// }
// 获取距离bottom
function getRangeNumber() {
  let rannum = 2;
  // if (deviceInfoData.value?.device?.cameras && deviceInfoData.value?.device?.cameras.length) {
  //   if (vedioType.value == 'zoom') {
  //     rannum = deviceInfoData.value?.device?.cameras[0]?.zoom_factor
  //   }
  //   if (vedioType.value == 'ir') {
  //     rannum = deviceInfoData.value?.device?.cameras[0]?.ir_zoom_factor
  //   }
  // }else{
  // }
  rannum = zoomNumMqtt.value;
  let num = parseFloat(((rannum / (200 - 2)) * 100).toFixed(4));
  if (num < 0) {
    num = 0;
  }
  if (num > 100) {
    num = 100;
  }
  const str = num + "%";
  return str;
}
</script>
<style lang="scss" scoped>
.controls-box1 {
  width: 100%;
  height: 100%;
  display: flex;
  // background: #F0F2F5;
  background: rgba(51, 51, 51, 0.65);
  // padding: 0 5px 5px;
  .blocks1 {
    width: 13px;
    height: 13px;
    background: red;
    // margin-right: 5px;
  }
  // 按钮
  .pod-btn1 {
    line-height: 1.1;
    position: relative;
    display: inline-block;
    white-space: nowrap;
    text-align: center;
    border: 1px solid transparent;
    // box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    // box-shadow: 0 0 #0000;
    cursor: pointer;
    height: 24px;
    padding: 4px;
    font-size: 14px;
    border-radius: 2px;
    border-color: #b9d9ed;
    font-weight: 500;
    // background: #464c55;
    color: #b9d9ed;
    // color: rgba(0, 0, 0, 0.85);
    transition: box-shadow 0.1s ease;
    &:hover {
      color: #009bff;
      background-color: rgba(0, 155, 255, 0.2);
      // background-color: #6B727D;
      border-color: #009bff;
      // box-shadow: inset 0 0 10px #00c1ff80;
    }
  }
  .pod-btn-active {
    color: #009bff;
    background-color: rgba(0, 155, 255, 0.2);
    border-color: #009bff;
    // box-shadow: inset 0 0 10px #00c1ff80;
  }
  .pod-line1 {
    width: 1px;
    height: 80%;
    background-color: #6b727d;
    margin: 0 5px;
  }
  .pod-header1 {
    // background-color: #ececec;
    background: rgb(51, 51, 51, 0.65);
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #e7f9ff;
    // color: #333;
    padding: 0px 10px;
    border-bottom: 1px solid #29a2ff40;
    &:deep(.ant-switch) {
      background-color: #3d3d3d !important;
    }
    &:deep(.ant-switch-checked) {
      background-color: #1890ff !important;
    }
  }
  .mt10 {
    margin-top: 10px;
  }
  // 吊舱操作
  .pod-box1 {
    flex: 3;
    height: 100%;
    border: 1px solid #29a2ff40;
    // border: 1px solid #0685e5;

    .pod-content1 {
      height: calc(100% - 32px);
      width: 100%;
      display: flex;
      padding-right: 25px;
      padding-left: 5px;
      // justify-content: space-evenly;
      .pod-btn-box1 {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
      }
      .pod-img-box {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
        }
      }
      .gimbal-option1 {
        // margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        height: 100%;
        margin-right: 5px;
        .gimbal-option-item1 {
          background: #464c55;
          margin-bottom: 2px;
        }
      }
      .ptz-circle1 {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #00c1ffa6;
        // background-color: #fff;
      }
      //   四个方向
      .operate-direction1 {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .ptz-cell {
          position: absolute;
        }

        .ptz-block1 {
          width: 100px;
          height: 100px;
          text-align: center;
          position: relative;
          font-size: 22px;
          color: #b9d9ed99;
          // color: #ccc;
          // background: #464c55;
          background: rgba(185, 217, 237, 0.2);
          // background: #1a19196b;
          // border: 1px solid #6B727D;
          border: 2px solid rgba(185, 217, 237, 0.6);
          border-radius: 50%;
          cursor: pointer;
        }
        .ptz-circle-center {
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .ptz-up {
          top: 0;
          left: 30px;
        }
        .ptz-right {
          top: 30px;
          right: 0px;
        }
        .ptz-down {
          bottom: 0;
          left: 30px;
        }
        .ptz-left {
          top: 30px;
          left: 0px;
        }
        .ptz-center {
          top: 20px;
          left: 45px;
          border-radius: 25px;
        }
        .ptz-box {
          width: 40px;
          display: inline-block;
          height: 40px;
          // background: #fff;
          border-radius: 50%;
          font-size: 20px;
          line-height: 40px;
          &:hover {
            // color: #1fa3f6;
            color: #00c1ff;
          }
        }
      }
      .operate-plus-box {
        height: 80%;
        width: 30px;
        border-radius: 15px;
        border: 1px solid #b9d9ed;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        margin-left: 5px;
        cursor: pointer;
        .ptz-add1 {
          color: #e7f9ff6e;
          &:hover {
            color: #00c1ff;
          }
        }
      }
      // 焦距刻度尺
      .con-zoom-scale-box1 {
        height: 100%;
        display: flex;
        width: 20px;
        justify-content: center;
        align-items: center;
        margin-left: 30px;
        padding-bottom: 10px;
        .con-zoom-scale1 {
          height: 100px;
          width: 2px;
          display: flex;
          background: #00c1ffa6;
          position: relative;
          .con-current-scale {
            // width: 10px;
            // height: 10px;
            // border-radius: 50%;
            // background-color: #00D590;
            // margin-left: -4px;
            // display: flex;
            // align-items: center;
            // justify-content: center;
            // position: absolute;
            // margin-bottom: -8px;
            position: absolute;
            transform: rotate(90deg) translateX(-50%);
            left: -15px;
            font-size: 10px;
            display: block;
            margin-bottom: -8px;
            &:before {
              content: "";
              display: block;
              width: 0;
              height: 0;
              border-left: 4px solid transparent;
              border-right: 4px solid transparent;
              border-bottom: calc(4px + 1px) solid transparent;
              position: absolute;
              bottom: 100%;
            }
            .con-current-scale-inner {
              font-size: 8px;
              margin: 0.5px 1px 1px;
              display: block;
              width: 8px;
              height: 8px;
              background-color: #1fa3f6;
              position: relative;
              &:before {
                content: "";
                display: block;
                width: 0;
                height: 0;
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-bottom: 4px solid #1fa3f6;
                position: absolute;
                bottom: 100%;
              }
            }
          }
          .drag {
            background-color: transparent;
            z-index: 1;
          }
          .con-current-scale-label1 {
            color: #e7f9ff;
            font-size: 10px;
            line-height: 18px;
            position: absolute;
            left: -30px;
            // top: -6px;
            // transform: scale(0.8);
            margin-bottom: -8px;
          }
          .con-point-container {
            position: absolute;
            display: flex;
            align-items: flex-end;
            .con-point {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: #00c1ffa6;
              margin-bottom: -2px;
              margin-left: -2px;
              position: relative;
              z-index: 10;
            }
            .con-label1 {
              color: #1fa3f6;
              font-size: 10px;
              line-height: 18px;
              position: absolute;
              left: 6px;
              top: -6px;
              transform: scale(0.8);
            }
          }
        }
      }
    }
  }
  // 角度
  .deg-box1 {
    flex: 2;
    height: 100%;
    border-top: 1px solid #29a2ff40;
    border-bottom: 1px solid #29a2ff40;
    // border-top: 1px solid #ccc;
    // border-bottom: 1px solid #ccc;
    // margin: 0 10px;
    .mls-5 {
      margin-left: 5px;
    }
    .pod-titles {
      width: 110px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .params-boxs1 {
      min-width: 180px;
      margin-left: 10px;
      overflow: hidden;
    }
    .deg-content1 {
      display: flex;
      height: calc(100% - 32px);
      width: 100%;
    }
    // 云台偏航角
    .gimbal {
      // flex: 1;
      margin-left: 10px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: end;
      .yaw-editor {
        position: relative;
        width: 94px;
        height: 94px;
        margin-left: 6px;
        background: #333;
        border-radius: 50%;
        flex-shrink: 0;
        .yaw-limit {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          .limit-marker {
            width: 16px;
            height: 16px;
            padding: 1px;
            position: absolute;
            top: 0;
            display: flex;
            justify-content: center;
            left: calc(50% - 8px);
            transform-origin: center 47px;
            color: #e70102;
            &:before {
              content: "";
              display: block;
              background-color: currentColor;
              width: 1px;
            }
          }
        }
        .yaw-compass {
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .yaw-drone {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .yaw-gimbal {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          padding: 5px;
          .gimbal-icon {
            // position: absolute;
            transform: rotate(90deg) translateX(-50%);
            // left: -1px;
            &:before {
              content: "";
              display: block;
              width: 0;
              height: 0;
              border-left: 4px solid transparent;
              border-right: 4px solid transparent;
              border-bottom: calc(4px + 1px) solid transparent;
              position: absolute;
              bottom: 100%;
            }
            .gimbal-icon-inner {
              margin: 0.5px 1px 1px;
              display: block;
              width: 8px;
              height: 8px;
              background-color: #1fa3f6;
              position: relative;
              &:before {
                content: "";
                display: block;
                width: 0;
                height: 0;
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-bottom: 4px solid #1fa3f6;
                position: absolute;
                bottom: 100%;
              }
            }
          }
        }
        .angle-number {
          font-size: 12px;
          line-height: 16px;
          font-weight: 600;
          color: #00c1ff;
          display: flex;
          &:before {
            display: block;
            content: "";
            width: 3px;
            height: 5px;
            background: #00c1ff;
            box-shadow: 0 0 4px rgba(0, 0, 0, 0.5),
              -1px -1px 0 rgba(0, 0, 0, 0.5), 1px -1px 0 rgba(0, 0, 0, 0.5),
              -1px 1px 0 rgba(0, 0, 0, 0.5), 1px 1px 0 rgba(0, 0, 0, 0.5);
          }
          &:after {
            content: "°";
            position: absolute;
            right: 0;
            top: 0;
            transform: translateX(100%);
          }
        }
        .drone {
          top: -2px;
          left: 50%;
          transform: translate(-50%, -100%);
          display: flex;
          flex-direction: column-reverse;
          align-items: center;
          position: absolute;
        }
      }
    }
    .con-rod-box {
      flex: 1;
      display: flex;
      align-items: end;
      padding-bottom: 5px;
      .con-pitch-editor {
        padding-left: 25px;
        padding-right: 5px;
        position: relative;
        .pitch-bar {
          color: hsla(0, 0%, 100%, 0.2);
          box-shadow: 0 0 0 0.4px rgba(0, 0, 0, 0.6);
          width: 7px;
          height: 80px;
          background: currentcolor;
        }
        .con-markers {
          width: 7px;
          height: 2px;
          background-color: #fff;
          position: absolute;
          transform: translateY(-50%);
          box-shadow: 0 0 0 0.4px rgba(0, 0, 0, 0.6);
        }
        .zero-markers {
          width: auto;
          right: 0;
          left: 25px;
          top: 50%;
        }
        .limit-markers {
          background-color: #e70102;
          height: 1px;
          transform: translateY(-100%);
        }
        .gimbal-icons {
          position: absolute;
          transform: rotate(90deg) translateX(-50%);
          left: 10px;
          font-size: 10px;
          display: block;
          &:before {
            content: "";
            display: block;
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-bottom: calc(4px + 1px) solid transparent;
            position: absolute;
            bottom: 100%;
          }
          .gimbal-icons-inner {
            font-size: 8px;
            margin: 0.5px 1px 1px;
            display: block;
            width: 8px;
            height: 8px;
            background-color: #1fa3f6;
            position: relative;
            &:before {
              content: "";
              display: block;
              width: 0;
              height: 0;
              border-left: 4px solid transparent;
              border-right: 4px solid transparent;
              border-bottom: 4px solid #1fa3f6;
              position: absolute;
              bottom: 100%;
            }
          }
        }
        .con-angle-numbers {
          position: absolute;
          top: -24px;
          right: -3px;
          color: #00c1ff;
          // text-shadow: 0 0 4px rgba(0,0,0,.5), -1px -1px 0 rgba(0,0,0,.5), 1px -1px 0 rgba(0,0,0,.5), -1px 1px 0 rgba(0,0,0,.5), 1px 1px 0 rgba(0,0,0,.5);
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          display: flex;
          &:after {
            content: "°";
          }
        }
      }
    }
  }
  //   无人机操作
  .docksys-box1 {
    // flex: 1;
    width: 200px;
    height: 100%;
    // border: 1px solid #ccc;
    border: 1px solid #29a2ff40;
    .docksys-item-box1 {
      margin-top: 20px;
      height: calc(100% - 50px);
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      color: #e7f9ff;
    }
    .docksys-item1 {
      border: 1px solid #b9d9ed;
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-radius: 5px;
      cursor: pointer;
      &:hover {
        // border: 1px solid #29a2ff;
        border: 1px solid #00a3da;
        color: #00c1ff;
      }
      font-size: 14px;
      > img {
        width: 16px;
      }
    }
    .docksys-item-no1 {
      border: 1px solid #b9d9ed;
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-radius: 5px;
      cursor: no-drop;
      font-size: 14px;
      > img {
        width: 16px;
      }
    }
  }
  .fly-num-box1 {
    // flex: 2;
    width: 180px;
    // margin-left: 10px;
    .key-box {
      height: 100%;
      position: relative;
      border-top: 1px solid #29a2ff40;
      border-right: 1px solid #29a2ff40;
      border-bottom: 1px solid #29a2ff40;
      // border-top: 1px solid #ccc;
      // border-right: 1px solid #ccc;
      // border-bottom: 1px solid #ccc;
      .row {
        width: 155px;
        height: calc(100% - 32px);
        margin-left: 15px;
        &:v-deep {
          .ant-btn {
            font-size: 12px;
            padding: 0px 4px;
            margin-right: 5px;
            // margin-bottom: 5px;
          }
        }
      }
      .drone-control-direction {
        padding-top: 25px;
        position: relative;
        .word {
          width: 12px;
          margin-left: 2px;
          font-size: 12px;
          color: #e7f9ff;
        }
      }
      .line-top {
        width: 160px;
        /* height: 1px; */
        /* margin-left: -10px; */
        border: 1px dashed #ccc;
        // background: #ccc;
        top: -35px;
      }
      .check-direction {
        position: absolute;
        //   top: -45px;
        top: 0;
        //   &:deep(.ant-checkbox-wrapper) {
        //     color: #fff;
        //   }
        //   &:deep(.ant-checkbox-disabled + span) {
        //     color: #fff;
        //   }
      }
      .key-absolute {
        position: absolute;
      }
      .key-w {
        // top: -20px;
        top: 0;
        left: 40px;
      }
      .key-e {
        left: 85px;
      }
      .key-up {
        right: 0;
      }
      .key-s {
        top: 25px;
        left: 40px;
      }
      .key-d {
        left: 85px;
      }
      .key-down {
        right: 0;
      }
      .key-btn {
        border: 1px solid #b9d9ed;
        background: transparent;
        color: #e7f9ff;
      }
    }
  }
}
</style>